import React, { Component } from 'react';
import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { connect } from 'react-redux';
import saga from '../../sagas/circle/new';
import Module from '../../modules/circle/new';
import ModalAlert from '../../components/modal/modal_alert';

const sagaMiddleware = createSagaMiddleware();
createStore(Module.reducer, applyMiddleware(sagaMiddleware));
sagaMiddleware.run(saga);

export default class FormPage2 extends Component {
  render() {
    return (
      <Root
        isApp={this.props.isApp}
        talkroomId={this.props.talkroomId}
        companyId={this.props.companyId}
        type={this.props.type}
      />
    );
  }
}

class TmpRoot extends Component {
  constructor(props) {
    super(props);
    this.state = {
      is_request_required: this.props.circle.is_request_required ? '1' : '0',
    };

    this.onClickPageBtn = this.onClickPageBtn.bind(this);
    this.onSubmitBtn = this.onSubmitBtn.bind(this);
    this.onDraftBtn = this.onDraftBtn.bind(this);
    this.onChangeFields = this.onChangeFields.bind(this);
    this.onChangeIsRequestRequired = this.onChangeIsRequestRequired.bind(this);
    this.onChangeRecruitAgeGroups = this.onChangeRecruitAgeGroups.bind(this);
    this.toCirclePage = this.toCirclePage.bind(this);
    this.toMenu = this.toMenu.bind(this);
    this.handleValidation = this.handleValidation.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.modalIsOpen) {
      switch (nextProps.submitStatus) {
        case 'success':
          this.modalAlertSuccess.openModal();
          break;
        case 'error':
          this.modalAlertError.openModal();
          break;
      }
    }
  }

  componentDidMount() {
    this.handleValidation();
  }

  /**
   * 表示ページが変更された時の処理
   * @param {*} e
   */
  onClickPageBtn(e) {
    e.preventDefault();
    const circle = this.props.circle;
    this.props.updateCircle(circle);
    this.props.changePage(e.target.value);
  }

  onSubmitBtn(e) {
    e.preventDefault();
    let circle = this.props.circle;
    circle['is_draft'] = false;
    circle['talkroom_id'] = this.props.talkroomId;
    this.props.updateCircle(circle, true);
    this.props.updateCircleTag(circle, true);
  }

  onDraftBtn(e) {
    e.preventDefault();
    let circle = this.props.circle;
    circle['is_draft'] = true;
    this.props.updateCircle(circle);
    this.toMenu();
  }

  onChangeFields(e) {
    let circle = this.props.circle;
    circle[e.target.id] = e.target.value;
    this.props.changeFields(circle);
    this.handleValidation();
  }

  onChangeIsRequestRequired(e) {
    let circle = this.props.circle;
    circle[e.target.id] = e.target.value;
    this.props.changeFields(circle);
    this.handleValidation();
    this.setState({ is_request_required: e.target.value });
  }

  onChangeRecruitAgeGroups(e) {
    const recruitAge = e.target.value;
    let tmpRecruitAgeGroups = this.props.recruitAgeGroups;
    let position = tmpRecruitAgeGroups.indexOf(recruitAge);
    if (position === -1) {
      tmpRecruitAgeGroups.push(recruitAge);
    } else {
      tmpRecruitAgeGroups.splice(position, 1);
    }
    if (recruitAge !== '') {
      let circle = this.props.circle;
      circle[e.target.id] = e.target.value;
      this.props.changeFields(circle);

      this.setState({
        // recruitAgeGroups: tmpRecruitAgeGroups,
        unChecked: false,
      });
    } else {
      this.setState({
        // recruitAgeGroups: [''],
        unChecked: true,
      });
    }
  }

  toCirclePage() {
    if (this.props.circle.company_id) {
      window.location.href =
        '/community/' +
        this.props.companyId +
        '/circle/' +
        this.props.circle.id;
    } else {
      window.location.href = '/circle/' + this.props.circle.id;
    }
  }

  toMenu() {
    if (this.props.circle.company_id) {
      window.location.href =
        '/community/' +
        this.props.companyId +
        '/circle/' +
        this.props.circle.id;
    } else {
      window.location.href = '/menu';
    }
  }

  handleValidation() {
    if (
      this.props.circle.name &&
      !this.props.isDisableCreateCircle
    ) {
      this.props.validation(true);
    } else {
      this.props.validation(false);
    }
  }

  render() {
    const circleName = this.props.type === 'department' ? '部署' : 'サークル';
    return (
      <div>
        <main
          className="bg-gray h-100 pt-3 min-vh-100"
          style={{
            paddingBottom: this.props.isApp == false ? '180px' : '72px',
          }}
        >
          <div className="container col-md-8 col-lg-6">
            <ol className="list-unstyled list-makecircle d-flex text-center justify-content-center mt-3">
              <li
                className="list-makecircleitem text-fz-small"
                onClick={this.onClickPageBtn}
                value="2"
              >
                基本情報
              </li>
              <li
                className="list-makecircleitem text-fz-small active"
                onClick={this.onClickPageBtn}
                value="3"
              >
                設定
              </li>
            </ol>
            <p className="text-fz-14px text-fw-bold text-black-50 mb-2_5 mt-3">
              メンバー募集
            </p>
          </div>
          <div className="shadow-sm mb-2 bg-white">
            <div className=" container col-md-8 col-lg-6 p-3_5">
              <select
                name=""
                id="recruit_status"
                className="p-0 w-100 textarea--eventreport custom-select custom-select--makecircle"
                placeholder="メンバー募集"
                onChange={this.onChangeFields}
                defaultValue={this.props.circle.recruit_status}
              >
                <option value="1">募集中</option>
                <option value="2">イベント参加した人のみ募集中</option>
                <option value="0">募集中止</option>
              </select>
            </div>
          </div>
          <div className="container col-md-8 col-lg-6">
            <p className="text-fz-14px text-fw-bold text-black-50 mb-2_5 mt-3">
              {circleName}参加時の承認
            </p>
          </div>
          <div className="shadow-sm mb-2 bg-white">
            <div className="container col-md-8 col-lg-6 p-3_5">
              <select
                name=""
                id="is_request_required"
                className="p-0 w-100 textarea--eventreport custom-select custom-select--makecircle"
                placeholder="メンバーによるイベント作成の許可を選択"
                onChange={this.onChangeIsRequestRequired}
                defaultValue={this.state.is_request_required}
              >
                <option value="0">不要({circleName}参加時に承認が不要)</option>
                <option value="1">必要({circleName}参加時に承認が必要)</option>
              </select>
            </div>
          </div>
          {this.state.is_request_required === '0' ? (
            ''
          ) : (
            <React.Fragment>
              <div className="container col-md-8 col-lg-6">
                <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3">
                  自己紹介テンプレート
                </p>
              </div>
              <div className="shadow-sm mb-0 bg-white pt-3 pb-3">
                <div className=" container col-md-8 col-lg-6">
                  <textarea
                    name=""
                    id="description"
                    cols="5"
                    rows="5"
                    className="p-0 w-100 textarea--eventreport"
                    placeholder="参加時に教えてもらいたい事を記載
                    例)年齢とスポーツ歴を書いてください。"
                    onChange={this.onChangeFields}
                    defaultValue={(() => {
                      if (this.props.circle.description) {
                        return this.props.circle.description;
                      } else if (
                        this.props.circle.circles_self_introduction_template !==
                        undefined
                      ) {
                        return this.props.circle
                          .circles_self_introduction_template.description;
                      } else {
                        return '';
                      }
                    })()}
                  />
                </div>
              </div>
            </React.Fragment>
          )}

          <div className="container col-md-8 col-lg-6">
            <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3">
              イベント参加者との個人間メッセージ
            </p>
            <p className="text-fz-12px text-fw-normal text-black-50 mb-2 mt-3">
              個人間メッセージを作成した場合、参加者一人一人にメッセージを送れます。
            </p>
            <p className="text-fz-12px text-fw-normal text-black-50 mb-2 mt-3">
              ここで「作成しない」を選択した場合も、クリエイターはイベント参加者一覧の「メッセージ」から個人間メッセージを送れます。
            </p>
          </div>
          <div className="shadow-sm mb-3 bg-white">
            <div className=" container col-md-8 col-lg-6 p-3_5">
              <select
                name=""
                id="attendance_notice_target"
                className="p-0 w-100 textarea--eventreport custom-select custom-select--makecircle"
                placeholder="イベント参加時の通知先を選択"
                onChange={this.onChangeFields}
                defaultValue={this.props.circle.attendance_notice_target}
              >
                <option value="0">オーナーと全クリエイターとの間に作成</option>
                <option value="1">オーナーとイベント作成者との間に作成</option>
                <option value="2">イベント作成者との間に作成</option>
                <option value="3">オーナーとの間に作成</option>
                <option value="4">作成しない</option>
              </select>
            </div>
          </div>

          <div className="container col-md-8 col-lg-6">
            <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3">
              {circleName}の公開・非公開
            </p>
          </div>
          <div className="shadow-sm mb-3 bg-white">
            <div className=" container col-md-8 col-lg-6 p-3_5">
              <select
                name=""
                id="private_status"
                className="p-0 w-100 textarea--eventreport custom-select custom-select--makecircle"
                placeholder="メンバーによるイベント作成の許可を選択"
                onChange={this.onChangeFields}
                defaultValue={this.props.circle.private_status}
              >
                <option value="0">公開</option>
                <option value="1">非公開</option>
              </select>
            </div>
          </div>
        </main>
        <div className="fixed-bottom" style={{ paddingBottom: '8px' }}>
          <div className="container col-md-8 col-lg-6">
            <div
              className="row"
              style={{ marginBottom: this.props.isApp == true ? '24px' : '' }}
            >
              <div className="col-4">
                <button
                  type="button"
                  className={`p-0 w-100 a-button a-button__top a-button__top--outline ${
                    this.props.isApp == false ? 'mb-2' : ''
                  }`}
                  onClick={this.onClickPageBtn}
                  value="2"
                >
                  戻る
                </button>
              </div>
              <div className="col-4">
                <button
                  type="button"
                  className={`p-0 w-100 a-button a-button__top a-button__top--outline ${
                    this.props.isApp == false ? 'mb-2' : ''
                  }`}
                  onClick={this.onDraftBtn}
                  id="is_draft"
                  value="true"
                >
                  下書き
                </button>
              </div>
              <div className="col-4">
                <button
                  type="button"
                  onClick={this.onSubmitBtn}
                  id="is_draft"
                  value="false"
                  className={`a-button a-button__top a-button--orange text-white p-0 w-100 ${
                    this.props.isApp == false ? 'mb-2' : ''
                  }`}
                  disabled={!this.props.isValidated}
                >
                  作成する
                </button>
              </div>
            </div>
          </div>
        </div>
        <ModalAlert
          ref={(c) => {
            this.modalAlertSuccess = c;
          }}
          id="modalAlertSuccess"
          title={`${circleName}の作成が完了しました`}
          content={`この${circleName}で、イベントページを作成しましょう！`}
          approveFunc={this.toCirclePage}
        />
        {/* 投稿失敗時 */}
        <ModalAlert
          ref={(c) => {
            this.modalAlertError = c;
          }}
          id="modalAlertError"
          title={`${circleName}作成失敗`}
          content={`${circleName}作成に失敗しました。時間をおいてもう一度お試しください。`}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    ...state,
    isApp: ownProps.isApp,
    talkroomId: ownProps.talkroomId,
    type: ownProps.type,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changePage: (pageNum) => {
      dispatch(Module.actions.changePage({ pageNum }));
    },
    changeFields: (circle) => {
      dispatch(Module.actions.changeFields({ circle }));
    },
    updateCircle: (circle, isSubmit = false) => {
      dispatch(Module.actions.updateCircle({ circle, isSubmit }));
    },
    updateCircleTag: (circle, isSubmit = false) => {
      dispatch(Module.actions.updateCircleTag({ circle, isSubmit }));
    },
    validation: (isValidated) => {
      dispatch(Module.actions.validation({ isValidated }));
    },
  };
};

const Root = connect(mapStateToProps, mapDispatchToProps)(TmpRoot);
